import { render, staticRenderFns } from "./header-settings.vue?vue&type=template&id=c4e2356c&scoped=true&"
import script from "./header-settings.vue?vue&type=script&lang=js&"
export * from "./header-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e2356c",
  null
  
)

export default component.exports